/* TOKYO LILY — タレント一覧（/blogs/talent）
   ・全件の取得と並べ替え（TL-04）
     Liquid の blog.articles は「公開日が新しい順」にしかページ分割できないため、
     サーバー描画だけでは 1 ページ目が「新着24人」になり、その中を順位で並べても
     1 位からにならない。そこで /blogs/talent?view=talent-json の全ページを取得・統合し、
     全員を 1 位から並べ直す（templates/blog.talent-json.liquid）。
     取得に失敗したときはサーバー描画のカードとページ送りをそのまま使う。
   ・並びは 過去30日ランキング（data-rank30 / 既定）・年間ランキング（data-annual）・
     更新順（data-upd = 更新日時 epoch）の3種。順位バッジも選択中のランキングに合わせる。
   ・ティアタブ（TL-03）は絞り込みのみ。カード自体はティアで見た目を分けない
     （TOP と同じ .tl-card。ティアはカード上部のチップで表す）。
   ・次回出演予定（TL-10）は 2026-09-30 デザイン指示（依頼7）で削除済み。
   ・キーワード検索：カードの data-search（記事名＋表示名＋英語名）に部分一致するものだけを出す。
     全角／半角・ひらがな／カタカナ・大文字／小文字・空白の違いは無視する。
*/
(function () {
  'use strict';

  /* 想定外のページ数で大量リクエストにならないよう上限を設ける */
  var MAX_PAGES = 20;
  var NO_RANK = 99999;

  /* ── 小物 ───────────────────────────────── */

  function attrNum(card, key, fallback) {
    var v = parseInt(card.dataset[key], 10);
    return isNaN(v) ? fallback : v;
  }

  /* 検索用の正規化：NFKC（全角英数→半角など）→ 小文字 → カタカナをひらがなに → 空白・中黒を除去 */
  function normalize(str) {
    var v = String(str || '');
    if (v.normalize) v = v.normalize('NFKC');
    return v.toLowerCase()
      .replace(/[\u30a1-\u30f6]/g, function (ch) { return String.fromCharCode(ch.charCodeAt(0) - 0x60); })
      .replace(/[\s\u3000・･]/g, '');
  }

  function searchText(card) {
    if (card._tlSearch === undefined) {
      card._tlSearch = normalize((card.dataset.search || '') + ' ' + (card.dataset.name || ''));
    }
    return card._tlSearch;
  }

  function setChildren(parent, nodes) {
    var frag = document.createDocumentFragment();
    nodes.forEach(function (n) { frag.appendChild(n); });
    parent.innerHTML = '';
    parent.appendChild(frag);
  }

  /* ── 描画 ───────────────────────────────── */

  /* 絞り込み＋並べ替え済みのカード配列。
     ランク未設定は 99999 で末尾。同順位・更新順は更新日時の新しい順。 */
  function visibleCards(st) {
    var list = st.tier === 'all'
      ? st.cards.slice()
      : st.cards.filter(function (c) { return c.dataset.tier === st.tier; });
    if (st.query) {
      list = list.filter(function (c) { return searchText(c).indexOf(st.query) !== -1; });
    }

    var rankKey = st.mode === 'annual' ? 'annual' : 'rank30';
    var byRank = st.mode !== 'updated';
    list.sort(function (a, b) {
      if (byRank) {
        var d = attrNum(a, rankKey, NO_RANK) - attrNum(b, rankKey, NO_RANK);
        if (d !== 0) return d;
      }
      return attrNum(b, 'upd', 0) - attrNum(a, 'upd', 0);
    });
    return list;
  }

  /* 順位バッジを選択中のランキングの順位に合わせる（未設定のカードは非表示）。
     更新順のときは並びと食い違うので CSS（[data-sort="updated"]）側で隠す。 */
  function updateBadge(card, mode) {
    var badge = card.querySelector('[data-rank-badge]');
    if (!badge) return;
    var v = attrNum(card, mode === 'annual' ? 'annual' : 'rank30', NO_RANK);
    badge.classList.remove('r1', 'r2', 'r3');
    if (v >= NO_RANK) { badge.hidden = true; return; }
    badge.hidden = false;
    if (v <= 3) badge.classList.add('r' + v);
    var num = badge.querySelector('[data-rank-num]');
    if (num) num.textContent = v;
  }

  function render(st) {
    var list = visibleCards(st);
    if (st.shown < st.chunk) st.shown = st.chunk;
    var slice = list.slice(0, st.shown);

    setChildren(st.grid, slice);
    slice.forEach(function (card) { updateBadge(card, st.mode); });

    if (st.noResult) st.noResult.hidden = list.length > 0;

    /* 「もっと見る」は全件を取得できたときだけ。残りが無ければ隠す */
    if (st.moreWrap) {
      var rest = list.length - slice.length;
      st.moreWrap.hidden = !(st.complete && rest > 0);
      /* 残り人数の表示（あと○名）は 2026-10-04 依頼22 で削除。ボタンは「もっと見る」だけ */
    }
  }

  /* ティアタブの件数は「取得できた全カード」で数える */
  function updateCounts(st) {
    var counts = { all: 0, pickup: 0, new_face: 0, standard: 0 };
    st.cards.forEach(function (card) {
      counts.all += 1;
      var t = card.dataset.tier;
      if (Object.prototype.hasOwnProperty.call(counts, t)) counts[t] += 1;
    });
    st.tabs.forEach(function (tab) {
      var el = tab.querySelector('.tab-count');
      if (el) el.textContent = counts[tab.dataset.tierTab] || 0;
    });
  }

  /* ── 全件取得 ───────────────────────────── */

  function loadAll(st) {
    var src = st.wrap.dataset.tlJsonSrc;
    if (!src || !window.fetch || !window.Promise) return Promise.resolve(false);

    /* テーマプレビュー中はプレビュー対象テーマで取得する */
    var previewId = null;
    try {
      previewId = new URLSearchParams(window.location.search).get('preview_theme_id');
    } catch (e) { /* URLSearchParams 非対応 */ }

    function fetchPage(page) {
      var url = src + '&page=' + page + (previewId ? '&preview_theme_id=' + encodeURIComponent(previewId) : '');
      return fetch(url, { credentials: 'same-origin' })
        .then(function (res) {
          if (!res.ok) throw new Error('HTTP ' + res.status);
          return res.text();
        })
        .then(function (text) { return JSON.parse(text); });
    }

    return fetchPage(1)
      .then(function (first) {
        var pages = Math.min(parseInt(first.pages, 10) || 1, MAX_PAGES);
        var rest = [];
        for (var p = 2; p <= pages; p++) rest.push(fetchPage(p));
        return Promise.all(rest).then(function (others) { return [first].concat(others); });
      })
      .then(function (all) {
        var html = '';
        all.forEach(function (data) {
          if (data && data.cards && data.cards.length) html += data.cards.join('');
        });
        if (!html) return false;

        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var fetched = Array.prototype.slice.call(tmp.querySelectorAll('[data-talent]'));
        if (!fetched.length) return false;

        /* サーバー描画済みのカードは使い回す（画像を読み込み直さないため）。
           取得したカードのうち、まだ画面に無いものだけを新しい要素として足す。 */
        var known = {};
        st.cards.forEach(function (card) {
          var key = card.dataset.name;
          if (key) known[key] = card;
        });
        st.cards = fetched.map(function (card) {
          var key = card.dataset.name;
          if (key && Object.prototype.hasOwnProperty.call(known, key)) return known[key];
          return card;
        });
        st.complete = true;
        return true;
      });
  }

  /* ── セットアップ ───────────────────────── */

  function setup(wrap) {
    if (wrap.dataset.tlInit === '1') return;
    wrap.dataset.tlInit = '1';

    var grid = wrap.querySelector('[data-talent-grid]');
    if (!grid) return;

    var select = wrap.querySelector('[data-talent-sort]');
    var st = {
      wrap: wrap,
      grid: grid,
      cards: Array.prototype.slice.call(grid.querySelectorAll('[data-talent]')),
      tabs: Array.prototype.slice.call(wrap.querySelectorAll('.tier-tab[data-tier-tab]')),
      moreWrap: wrap.querySelector('[data-talent-more-wrap]'),
      noResult: wrap.querySelector('[data-talent-noresult]'),
      chunk: parseInt(wrap.dataset.tlChunk, 10) || 48,
      shown: 0,
      tier: 'all',
      query: '',
      /* 戻る操作などでセレクトの選択が復元されていればそれに従う */
      mode: select ? select.value : 'rank30',
      complete: false
    };

    wrap.dataset.sort = st.mode;
    updateCounts(st);
    render(st);

    /* ティアタブ（絞り込み。件数は全件ベース） */
    st.tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        st.tabs.forEach(function (t) { t.classList.remove('active'); });
        tab.classList.add('active');
        st.tier = tab.dataset.tierTab;
        st.shown = 0;
        render(st);
      });
    });

    /* 並び替え */
    if (select) {
      select.addEventListener('change', function () {
        st.mode = select.value;
        wrap.dataset.sort = st.mode;
        st.shown = 0;
        render(st);
      });
    }

    /* キーワード検索（入力のたびに絞り込む。送信してもページ遷移しない） */
    var searchInput = wrap.querySelector('[data-talent-search]');
    var searchForm = wrap.querySelector('[data-talent-search-form]');
    if (searchInput) {
      var timer = null;
      var apply = function () {
        var q = normalize(searchInput.value);
        if (q === st.query) return;
        st.query = q;
        st.shown = 0;
        render(st);
      };
      searchInput.addEventListener('input', function () {
        clearTimeout(timer);
        timer = setTimeout(apply, 150);
      });
      if (searchForm) {
        searchForm.addEventListener('submit', function (e) {
          e.preventDefault();
          clearTimeout(timer);
          apply();
          searchInput.blur();  /* スマホのキーボードを閉じる */
        });
      }
      /* 戻る操作などで入力が復元されていれば反映する */
      if (searchInput.value) apply();
    }

    /* もっと見る */
    var moreBtn = wrap.querySelector('[data-talent-more]');
    if (moreBtn) {
      moreBtn.addEventListener('click', function () {
        st.shown += st.chunk;
        render(st);
      });
    }

    /* 全件を取得して 1 位から並べ直す。失敗したらサーバー描画のまま */
    loadAll(st)
      .then(function (ok) {
        if (!ok) return;
        /* 全件を「もっと見る」で出すのでサーバーのページ送りは取り除く */
        var pager = wrap.querySelector('[data-talent-pager]');
        if (pager && pager.parentNode) pager.parentNode.removeChild(pager);
            updateCounts(st);
        st.shown = 0;
        render(st);
      })
      .catch(function () { /* 失敗時はサーバー描画のまま */ });
  }

  function init(root) {
    (root || document).querySelectorAll('[data-talent-list]').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  /* テーマエディタでの再描画にも対応 */
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
    if (window.TokyoLily && window.TokyoLily.initReveal) window.TokyoLily.initReveal(e.target);
  });
})();
